<template>
  <div class="width-full flex week">
    <div
      v-for="(item, index) in getWeeks"
      :key="index"
      class="txt-center"
      :class="index == 0 ? 'first-cell' : 'other-cell'"
    >
      <div
        class="head-title width-full deep-bg flex-c-c"
        :class="index == 7 && 'border-right'"
      >
        <span class="white-s-nowrap size18 font-w-b"
          >{{ dayText[index] }}&ensp;{{ item.dateText }}</span
        >
      </div>
      <div
        v-for="(i, j) in item.time"
        :key="j"
        class="cell-height size18"
        :class="index == 0 ? 'deep-bg flex-c-c' : 'fle-c-s'"
      >
        <div :class="index == 0 && 'blue-bold'">
          {{ index == 0 ? i.timeText : "" }}
        </div>
        <div
          class="cell-content txt-left active flex-col-s-s"
          v-if="i.timeList.length"
        >
          <div class="bar"></div>
          <p
            v-for="(e, d) in i.timeList.slice(0, 2)"
            class="txt-hide1 txt-left"
            :class="{
              'theme-red': e.type == 1,
              'theme-blue': e.type == 2,
            }"
            :key="d"
            @click="showDetail(e)"
          >
            {{ e.scheduleName }}
          </p>
          <p
            class="more"
            v-if="i.timeList.length >= 3"
            @click="toMore(item.dateText)"
          >
            更多{{ i.timeList.length - 2 }}个日程
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["passTime", "callBack"],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dayText: {
        0: "",
        1: "周一",
        2: "周二",
        3: "周三",
        4: "周四",
        5: "周五",
        6: "周六",
        7: "周日",
      },
    };
  },
  computed: {
    // 传入的二维数组转成一维数组,并转成对象
    getListKey() {
      const obj = {};
      const oneList = this.list.reduce((all, cur) => {
        const list = cur.list || [];
        list.forEach((i) => {
          i.parentDate = cur.date;
        });
        return all.concat(list);
      }, []);
      oneList.forEach((item) => {
        if (item.date == "allDay") {
          // 全天
          const ad = new Date(item.parentDate.replace(/-/g, "/"));
          obj[
            `${ad.getFullYear()}_${ad.getMonth() + 1}_${ad.getDate()}_allDay`
          ] = item.list;
        } else {
          // 0-23小时
          const d = new Date(item.date.replace(/-/g, "/"));
          obj[
            `${d.getFullYear()}_${
              d.getMonth() + 1
            }_${d.getDate()}_${d.getHours()}`
          ] = item.list;
        }
      });
      return obj;
    },
    // 获取当前月日
    getMonthDate() {
      return (date) => {
        return `${date.getMonth() + 1}/${date
          .getDate()
          .toString()
          .padStart(2, "0")}`;
      };
    },
    // 获取星期
    getDay() {
      const day = this.passTime().getDay();
      return day == 0 ? 7 : day;
    },
    // 获取每周每天每小时
    getWeeks() {
      const date = this.passTime();
      const arr = Array.from(
        {
          length: 7,
        },
        (i, index) => {
          // 日期
          const d = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - (this.getDay - 1 - index)
          );
          const headkey = `${d.getFullYear()}_${
            d.getMonth() + 1
          }_${d.getDate()}_allDay`;
          return {
            date: d,
            dateText: this.getMonthDate(d),
            time: [
              { timeText: "全天", timeList: this.getListKey[headkey] || [] },
            ].concat(
              Array.from(
                {
                  length: 24,
                },
                (j, k) => {
                  const key = `${d.getFullYear()}_${
                    d.getMonth() + 1
                  }_${d.getDate()}_${k.toString().padStart(2, "0")}`;
                  return {
                    timeText: k.toString().padStart(2, 0),
                    timeList: this.getListKey[key] || [],
                  };
                }
              )
            ),
          };
        }
      );
      arr.unshift({
        date: null,
        dateText: "时间",
        time: [{ timeText: "全天", timeList: [] }].concat(
          Array.from(
            {
              length: 24,
            },
            (j, k) => {
              return {
                timeText: k.toString().padStart(2, 0),
                timeList: [],
              };
            }
          )
        ),
      });
      return arr;
    },
  },
  methods: {
    showDetail(i) {
      if (i.type == 2) {
        this.$emit("toDetail", i.id);
      } else if (i.type == 1) {
        this.$router.push({
          path: "/plan/detail",
          query: {
            drillId: i.drillId,
            type: 2,
            time: +this.passTime()
          },
        });
      }
    },
    toMore(value) {
      const current = `${this.passTime().getFullYear()}/${value}`;
      // 更多日程
      this.$emit("toMore", current);
    },
  },
  created() {},
};
</script>
<style lang='less' scoped>
.week {
  border-top: 1px solid rgba(65, 73, 116, 0.3);
  border-left: 1px solid rgba(65, 73, 116, 0.3);
  overflow: hidden;
  .deep-bg {
    // background: #1c2242;
  }
  .head-title {
    height: 90px;
    > span {
      color: #1890ff;
    }
  }
  .blue-bold {
    color: #1890ff;
    font-weight: bold;
  }
  .first-cell {
    width: 7.6%;
  }
  .other-cell {
    width: 13.2%;
  }
  .cell-height {
    height: 127px;
    border-right: 1px solid rgba(65, 73, 116, 0.3);
    border-bottom: 1px solid rgba(65, 73, 116, 0.3);
    overflow: hidden;
  }
  .border-right {
    border-right: 1px solid rgba(65, 73, 116, 0.3);
  }
  .cell-content {
    position: relative;
    height: 100%;
    .bar {
      display: none;
    }
    > p {
      width: 100%;
      line-height: 37px;
      font-size: 14px;
      color: white;
      margin-bottom: 0;
      padding: 0 20px;
      box-sizing: border-box;
      margin-bottom: 8px;
      &:nth-last-of-type(1) {
        margin-top: 0;
      }
    }
    > .more {
      text-align: right;
      margin-bottom: 0;
      line-height: 37px;
    }

    &.active {
      background: rgba(24, 144, 255, 0.05);
      .bar {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 6px;
        background: #1890ff;
        display: block;
      }
      .theme-red {
        background: #f563ae;
        color: white;
      }
      .theme-blue {
        background: #38cbba;
      }
    }
  }
}
</style>